import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { Resolve } from '@angular/router';
import {
  POSTCODE_REGEX,
  QuoteParamsParserService,
  REFERENCE_NUMBER_REGEX,
} from '@common/util-foundation';
import {
  OfferFormSubmit,
  ParseResponse,
  ParseResult,
} from '@common/util-models';
import { OfferRenewalLandingPageFacade } from '@oren/data-access-offer-renewal';
import { formatReferenceNumber } from '@oren/util-foundation';
import {
  MonoTypeOperatorFunction,
  NEVER,
  Observable,
  of,
  OperatorFunction,
  pipe,
} from 'rxjs';
import { first, map, switchAll, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OfferQueryParamsResolver
  implements Resolve<Observable<ParseResponse<OfferFormSubmit>>>
{
  private postCodeValidation = [
    Validators.required,
    Validators.pattern(POSTCODE_REGEX),
  ];

  private referenceNumberValidation = [
    Validators.required,
    Validators.pattern(REFERENCE_NUMBER_REGEX),
  ];

  constructor(
    private offerRenewalFacade: OfferRenewalLandingPageFacade,
    private quoteParamsParserService: QuoteParamsParserService<OfferFormSubmit>
  ) {}

  resolve(): Observable<ParseResponse<OfferFormSubmit>> {
    return this.quoteParamsParserService
      .parse({
        referenceNumber: this.referenceNumberValidation,
        postCode: this.postCodeValidation,
      })
      .pipe(
        first(),
        this.submitQuoteIfParsingSuccessful(),
        this.waitIfParsingSuccessful()
      );
  }

  private submitQuoteIfParsingSuccessful(): MonoTypeOperatorFunction<
    ParseResponse<OfferFormSubmit>
  > {
    return pipe(
      tap((parsedResponse) => {
        const referenceNumber = formatReferenceNumber(
          parsedResponse.model?.referenceNumber
        );

        if (
          parsedResponse.result === ParseResult.Success &&
          parsedResponse.model &&
          referenceNumber
        ) {
          this.offerRenewalFacade.getEmailOffer(
            referenceNumber,
            parsedResponse.model?.postCode as string
          );
        }
      })
    );
  }

  private waitIfParsingSuccessful(): OperatorFunction<
    ParseResponse<OfferFormSubmit>,
    ParseResponse<OfferFormSubmit>
  > {
    return pipe(
      map((parsedResponse) =>
        parsedResponse.result === ParseResult.Success
          ? NEVER
          : of(parsedResponse)
      ),
      switchAll()
    );
  }
}
